import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export class CivilianRegistration
{
	public constructor(public id: string, public firstName: string, public lastName: string, public email: string, public password: string,
		public isAttorney: boolean, public lawSchoolName: string, public barNumber: string)
	{

	}
}

export interface PendingUserCivilian
{
	pendingUserCivilianId: string;
	civilianUserAlreadyExisted: boolean;
	newCivilianUserCreated: boolean;
	emailSent: boolean;
}

export class UserCivilianDto
{
	public constructor(public id: string)
	{

	}
}

@Injectable()
export class CivilianRegistrationRepository
{
	private requestMapping: string = "registrations";
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public createNewCivilianRegistration(civilianRegistration: CivilianRegistration): Observable<PendingUserCivilian>
	{
		return this.http.post<PendingUserCivilian>(this.requestMapping, civilianRegistration);
	}

	public resendConfirmationEmail(pendingCivilianUserId: string): Observable<void>
	{
		return this.http.post<void>(`${this.requestMapping}/resend/${pendingCivilianUserId}`, null);
	}

	public confirmNewCivilianRegistration(userId: string): Observable<UserCivilianDto>
	{
		return this.http.post<UserCivilianDto>(`${this.requestMapping}/${userId}/confirmation`, null);
	}

	public deleteCivilianAccount(): Observable<void>
	{
		return this.http.delete<void>("users");
	}
}
